import type { SupportCenterFormKind } from './supportCenterSpecialties'
import type { SupportCenterFormRef } from './supportCenterForms'

export type SupportCenterCoverageScope = 'titular' | 'dependentes'

export const SUPPORT_CENTER_COVERAGE_SCOPE_LABELS: Record<SupportCenterCoverageScope, string> = {
  titular: 'Somente Titular',
  dependentes: 'Titular e Dependentes',
}

export interface SupportCenterAssistance {
  id: string
  name: string
  code: string
  form_kind: SupportCenterFormKind | null
  specific_form_key: string | null
  specific_form: SupportCenterFormRef | null
  coverage_scope: SupportCenterCoverageScope
  created_at: string
  updated_at: string
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
}

export type SupportCenterAssistanceInput = {
  id?: string
  name: string
  code: string
  /** Vazio no formulário novo até o usuário escolher (opcional). */
  specific_form_key: string | ''
  /** Vazio no formulário novo até o usuário escolher. */
  coverage_scope: SupportCenterCoverageScope | ''
}

export type SupportCenterAssistanceRef = {
  id: string
  name: string
  code: string
}
